import styles from './PostsDayPopup.pcss'
import { PlannedPost, PostBase } from 'interfaces'
import { CalendarDay } from 'interfaces/Post/Calendar'
import MiniPostView from '../MiniPostView'
import Popper from '@mui/material/Popper'
import Paper from '@mui/material/Paper'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Close'
import { format } from 'date-fns'
import { overflowModifiers } from 'styles/popover'
import { CalendarPostSize } from 'services/post/state'

const PAPER_ELEVATION = 8

interface PostsDayPopupProps {
  day: CalendarDay | null
  posts: PostBase[]
  anchor: HTMLElement | null
  activePostId?: string
  postSize: CalendarPostSize
  onClose: () => void
  onPostClick: (post: PlannedPost) => void
}

export function PostsDayPopup(props: PostsDayPopupProps) {
  const { day, postSize, onPostClick } = props

  return (
    <Popper
      open={Boolean(props.anchor)}
      anchorEl={props.anchor}
      className={styles.popup}
      placement="bottom"
      modifiers={overflowModifiers}
    >
      <ClickAwayListener onClickAway={props.onClose}>
        <Paper className={styles.wrapper} elevation={PAPER_ELEVATION}>
          <div className={styles.header}>
            {day && (
              <div className={styles.day}>{format(day.date, 'EEE')}</div>
            )}
            {day && (
              <div className={styles.date}>{day.date.getDate()}</div>
            )}
            <IconButton className={styles['btn-close']} size="small" onClick={props.onClose}>
              <DeleteIcon />
            </IconButton>
          </div>
          <div className={styles.list}>
            {props.posts.map(post => (
              <MiniPostView
                key={post.id}
                post={post as PlannedPost}
                size={postSize}
                className={`${styles.post} ${props.activePostId === post.id ? styles.active : ''}`}
                onClick={onPostClick}
              />
            ))}
          </div>
        </Paper>
      </ClickAwayListener>
    </Popper>
  )
}

export default PostsDayPopup
